// removed by extract-text-webpack-plugin
module.exports = {"hot":"hot_HotSearches","active":"active_HotSearches"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotSearches/HotSearches.scss
// module id = 245
// module chunks = 0